import { getBusinessConfig } from '@da-vinci/utils'

export type BusinessConfig = {
  explore_hot_words: string[]
  oral_require_tip_content: string
  brief_oral_material_tenantId: string[]
}

export function getConfig() {
  return getBusinessConfig<BusinessConfig>(import.meta.env.VITE_BUSINESS_CONFIGURATION)
}

export function useGetConfig() {
  const { state: config, isLoading } = useAsyncState(getConfig, undefined)

  return { config, isLoading }
}
